namespace GeniuzPOS.CustomReport {
    export class ReportCusAgingColumns {
        static columnsKey = 'CustomReport.ReportCusAging';
    }
}
